/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IntegrationConfig } from '../models/IntegrationConfig';

export class UpdateIntegrationRequest {
  'config': IntegrationConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "config",
      "baseName": "config",
      "type": "IntegrationConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateIntegrationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

